import { ImageBanner, ImageBannerResponsive } from "./styles";

import BannerImage from "../../../assets/clubmed/banner.jpg";
import BannerImageResponsive from "../../../assets/clubmed/banner-responsive.jpg";

const Banner = () => {
  return (
    <section>
      <ImageBanner
        src={BannerImage}
        alt="banner"
        onClick={() =>
          document
            .querySelector("#register")
            .scrollIntoView({ behavior: "smooth" })
        }
      />
      <ImageBannerResponsive src={BannerImageResponsive} alt="banner" />
    </section>
  );
};

export default Banner;
